import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Clipboard from 'clipboard';
import Tooltip from 'praece-react-bootstrap/lib/Tooltip';
import Overlay from 'praece-react-bootstrap/lib/Overlay';

// Utils
import { stopPropagation } from 'utils/event-handlers';


export default class CopyToClipboard extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    copyText: PropTypes.string.isRequired,
    component: PropTypes.any,
    tooltip: PropTypes.string
  };

  constructor() {
    super();

    this.state = { alertCopied: false, mouseOver: false };

    this.instantiateClipboard = this.instantiateClipboard.bind(this);
  }

  componentDidMount() {
    this.instantiateClipboard();
  }

  instantiateClipboard() {
    const el = ReactDOM.findDOMNode(this);
    const clipboard = new Clipboard(el);
    
    clipboard.on('success', () => {
      this.setState({ alertCopied: true });
    });
  }

  render() {
    const { children, copyText, component, tooltip } = this.props;
    const { alertCopied, mouseOver } = this.state;

    const ElementType = component || 'div';

    return (
      <ElementType
        className="copy-to-clipboard"
        data-clipboard-text={copyText}
        onClick={stopPropagation()}
        onMouseOut={() => this.setState({ mouseOver: false })}
        onMouseOver={() => this.setState({ mouseOver: true })}
      >
        <Overlay placement="top" show={(tooltip || alertCopied) && mouseOver} target={this} shouldUpdatePosition>
          <Tooltip id="copy-to-clipboard">
            { alertCopied ? 'Copied' : tooltip }
          </Tooltip>
        </Overlay>

        {children}
      </ElementType>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/widgets/icons/copy-to-clipboard.js